import { Flex } from 'dash-ui';
import styled from 'styled-components';

export const CardContainer = styled(Flex)`
  flex-direction: row;
  align-items: stretch;
  margin-top: ${({ theme }) => theme.space * 8}px;
  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
    align-items: center;
    margin-top: ${({ theme }) => theme.space * 4}px;
  }
`;

export const HeaderContainer = styled(Flex)`
  flex-direction: row;
  margin-top: ${({ theme }) => theme.space * 10}px;
  justify-content: space-between;
  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
    margin-top: ${({ theme }) => theme.space * 4}px;
  }
`;

export const SwitchContainer = styled(Flex)`
  margin-top: 0px;
  @media ${({ theme }) => theme.devices.mobile} {
    margin-top: ${({ theme }) => theme.space * 4}px;
  }
`;
